var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"landing",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"col-10 mx-auto py-5 my-5"},[_c('h5',{staticClass:"section-title mb-5"},[_vm._v("Términos y condiciones")]),_c('section-accordion-terms')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }